import { createAction } from '@reduxjs/toolkit';

import {
  GET_VLEARN_APP_URL_REQUEST,
  GET_VLEARN_APP_URL_SUCCESS,
  GET_VLEARN_APP_URL_FAILURE,
} from './dashboard.const';

export const getVlearnAppRequest = createAction(GET_VLEARN_APP_URL_REQUEST);
export const getVlearnAppSuccess = createAction(GET_VLEARN_APP_URL_SUCCESS);
export const getVlearnAppFailure = createAction(GET_VLEARN_APP_URL_FAILURE);
